module.exports = __webpack_public_path__ + "img/facebook.52511c9f.svg";